import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";

// Helper function to validate whether a blog post is using the new rich text editor or legacy markdown
const IsRichTextValidator = richText => {
  // Easy check to see if the field is coming back from contentful
  if (!richText) {
    return false;
  }
  // Secondary check for cases where there may be whitespace in the rich text field but no actual content
  const richTextRaw = richText.raw;
  const richTextRootNode = JSON.parse(richTextRaw);
  const richTextString = documentToPlainTextString(richTextRootNode).trim();
  return richTextString.length > 0;
};

export default IsRichTextValidator;
